import React, { useState } from "react";
import Box from "@mui/material/Box";
import Tabs, { tabsClasses } from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import { styled } from "@mui/system";
import { Typography } from "@mui/material";
import { useNavigate,Outlet, Link,useLocation } from "react-router-dom";
import  router from "@/router"; 

const CustomTab = styled((props) => <Tab disableRipple   component={Link}{...props} />)(
  ({ theme }) => ({
    textTransform: "none",
    padding: "0px",
    minWidth: "auto",
  })
);

const TabLabel = styled("span")(({ theme }) => ({
  fontSize: 14,
  fontWeight: 600,
  lineHeight: "16.8px",
  fontFamily: "Lato,sans-serif",
  padding: "10px",
  display: "inline-block",
  whiteSpace: "nowrap",
  "&.Mui-selected": {
    backgroundColor: theme.palette.BudgieThemeColor.Primary[200],
    color: theme.palette.BudgieThemeColor.Neutrals[1300],
    borderRadius: "35px",
  },
  "&:not(.Mui-selected)": {
    backgroundColor: "white",
    color: theme.palette.BudgieThemeColor.Neutrals[1100],
  },
}));

const TabPanel = ({ value, index, children }) => {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`scrollable-auto-tabpanel-${index}`}
      aria-labelledby={`scrollable-auto-tab-${index}`}
      style={{ marginTop: "60px" }}
    >
      {value === index && <Box>{children}</Box>}
    </div>
  );
};

export default function ScrollableTabsButtonVisible({ tabs = [], title }) {
  const [value, setValue] = useState(0);
  const navigate = useNavigate();
  const showScrollButtons = tabs.length > 3; // Adjust the number as needed
  const Location = useLocation();

  const handleChange = (event, newValue) => {
    // console.log(tabs[newValue].component);
    setValue(newValue);
    // navigate(tabs[newValue].path);
  };
  const data=tabs.map((item)=>{
    return item.path;
  })

  return (
    <>
      <Box
        sx={{

          padding: "2px 0px 2px 0px",
          position: "", // Set fixed position
          // top: 0, // Align to top
          // marginBottom: "65px",
          // backdropFilter: "blur(10px)", // Add backdrop blur
          // zIndex: 1000, // Ensure it stays above other content
          // width: "100%", // Ensure full width
          background: "#FDF9F6",
          marginTop:"-25px",
          boxShadow: "none", 
          // width: {
          //   sm: `calc(100% - (92px + 44px))`,
          //   xs: `calc(100% - (30px + 20px))`,
          // },

        }}
      >
        <Box sx={{
          my: "10px", display: "flex",     
          }}>
          <Typography
            variant="h3"
            component="h3"
            sx={{ fontWeight: 700, fontSize: "28px !important", paddingLeft: "16px", whiteSpace: "nowrap",display: "flex", alignItems: "center", }}
          >
            {title}
          </Typography>

          <Box
            sx={{
              bgcolor: (theme) => theme.palette.BudgieThemeColor.BaseWhite,
              marginLeft: 2,
              // maxWidth: showScrollButtons ? "80%" : "calc(100% - 40px)", 
              overflowX: "auto",
              borderRadius: "35px",
            }}
          >
            <Tabs
            
              value={value}
              onChange={handleChange}
              TabIndicatorProps={{ sx: { transition: "none" } }}
              variant="scrollable"
              scrollButtons={showScrollButtons ? "auto" : false}
              aria-label="visible arrows tabs example"
              sx={{
                [`& .${tabsClasses.scrollButtons}`]: {
                  display: showScrollButtons ? "flex" : "none",
                  "&.Mui-disabled": { opacity: 0.3 },
                },
                "& .MuiTabs-indicator": {
                  display: "none",
                },
                "& .MuiTabs-flexContainer": {
                  marginRight: "12px",
                  marginLeft: "12px",
                },
                width: "100%",
                overflowX: "auto", // Enable horizontal scrolling
                display: "flex",
                justifyContent: "flex-start", // Align tabs to start
                flexWrap: "nowrap", // Prevent wrapping
              }}
            >
              {tabs.map((tab, index) => (
                <CustomTab
                  key={index}
                  // component={Link}
                  to={tab.path}
                  {...tab.props}
                  label={
                    <TabLabel className={tab.path== Location.pathname? "Mui-selected" : ""}>
                      {tab.text}
                    </TabLabel>
                  }
                />
              ))}
            </Tabs>
          </Box>
        </Box>
      </Box>
      {/* {tabs.map((tab, index) => (
        <TabPanel value={value} index={index} key={index}>
          {tab.component}
        </TabPanel>
      ))} */}
      
    </>
  );
}
